module.exports = __webpack_public_path__ + "img/yzh10.e4ebddb1.jpg";